<template>
  <div id="aplicacion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE INGRESO CURSO-->
              <v-card
                :key="cardIngreso"
                flat
                v-if="tabSelected == 'Resumen cobertura Aplicación'"
              >
                <grid-resumen-cobertura
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></grid-resumen-cobertura>
              </v-card>
              <!-- TAB DE CURSOS APLICADOS  -->
              <v-card
                :key="cardAplicados"
                flat
                v-if="tabSelected == 'Establecimiento NO Aplicados'"
              >
                <grid-establecimiento
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></grid-establecimiento>
              </v-card>
              <!-- TAB DE CURSOS NO APLICADOS -->
              <v-card
                :key="cardNoAplicados"
                flat
                v-if="tabSelected == 'Cursos No Aplicados'"
              >
                <grid-cursos-no-aplicados
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></grid-cursos-no-aplicados>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
//antes GridIngresoCurso
import GridResumenCobertura from "@/modules/aplicacion/views/aplicacion/GridResumenCobertura.vue";
//antes GridCursosAplicados
import GridEstablecimiento from "@/modules/aplicacion/views/aplicacion/GridEstablecimiento.vue";
import GridCursosNoAplicados from "@/modules/aplicacion/views/aplicacion/GridCursosNoAplicados.vue";

export default {
  name: "aplicacion-sub-tab",

  components: {
    GridResumenCobertura,
    GridEstablecimiento,
    GridCursosNoAplicados,
  },
  props: {},
  data: () => ({
    tabs: [
      "Resumen cobertura Aplicación",
      "Establecimiento NO Aplicados",
      "Cursos No Aplicados",
    ],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
    cardIngreso: 0,
    cardAplicados: 10,
    cardNoAplicados: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Ingreso Cursos RBD") {
        this.reloadIngreso();
      }
      if (this.tabSelected == "Cursos Aplicados") {
        this.reloadAplicados();
      }
      if (this.tabSelected == "Cursos No Aplicados") {
        this.reloadNoAplicados();
      }
    },
    reloadIngreso() {
      this.cardIngreso += 1;
    },

    reloadAplicados() {
      this.cardAplicados += 11;
    },

    reloadNoAplicados() {
      this.cardNoAplicados += 21;
    },
  },
};
</script>
